import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const AdminRoute = props => {
  const { isAdmin } = useContext(UserContext);

  if (isAdmin) {
    return <Route {...props} />;
  } else if (!isAdmin) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default AdminRoute;
